import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { InspirationChoiceTile } from "web_myplann/Inspiration/Components/InspirationChoiceTile";

type Props = {
	icon: LucideIcon;
	label: string;
	description?: string;
	uppercase?: boolean;
	selected: boolean;
	onClick: () => void;
};

export const RetirementIconTile: FC<Props> = ({
	icon: Icon,
	label,
	description,
	uppercase = false,
	selected,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<InspirationChoiceTile selected={selected} onClick={onClick} bordered>
			<Stack alignSelf="stretch" gap={theme.spacingTokens.xs}>
				<Stack direction="row" alignItems="center" gap={theme.spacingTokens.sm}>
					<Icon
						size={theme.iconSize.sm}
						color={selected ? theme.palette.blue.main : theme.palette.grey[400]}
					/>
					<Typography
						variant="button"
						color={selected ? theme.palette.blue.main : theme.palette.grey[500]}
						textTransform={uppercase ? "uppercase" : undefined}
					>
						{label}
					</Typography>
				</Stack>
				{description && (
					<Typography variant="hint" color={theme.palette.grey[500]}>
						{description}
					</Typography>
				)}
			</Stack>
		</InspirationChoiceTile>
	);
};
